import { render } from "./PriceSearchCard.vue?vue&type=template&id=1d8c1f1e&ts=true"
import script from "./PriceSearchCard.vue?vue&type=script&lang=ts"
export * from "./PriceSearchCard.vue?vue&type=script&lang=ts"

import "./PriceSearchCard.vue?vue&type=style&index=0&id=1d8c1f1e&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__